module.exports = __webpack_public_path__ + "img/insta-6.b6331a86.jpg";